'use strict';

var React = require('react');

var SvgListNumberedIcon = function SvgListNumberedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75Zm0 5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75Zm0 5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.75 3.38-.2.15a.5.5 0 1 1-.6-.8l.6-.45a.75.75 0 0 1 1.2.6v3h.5a.5.5 0 0 1 0 1h-2a.5.5 0 1 1 0-1h.5v-2.5Zm-1 5.87a1.5 1.5 0 1 1 3 0v.05a1.5 1.5 0 0 1-.503 1.122l-.932.828h.935a.5.5 0 0 1 0 1h-1.592c-.69 0-1.014-.852-.499-1.31l1.423-1.265a.5.5 0 0 0 .168-.375v-.05a.5.5 0 0 0-1 0 .5.5 0 0 1-1 0Zm.5 3.88a.5.5 0 0 0 0 1h1.188a.32.32 0 0 1 .312.32.506.506 0 0 1-.24.43h-.76a.5.5 0 0 0 0 1h.76c.145.088.24.252.24.43a.32.32 0 0 1-.312.32h-1.188a.5.5 0 0 0 0 1h1.188a1.32 1.32 0 0 0 1.312-1.32 1.51 1.51 0 0 0-.321-.93 1.51 1.51 0 0 0 .321-.93 1.32 1.32 0 0 0-1.312-1.32h-1.188Z"
  }));
};
SvgListNumberedIcon.displayName = "ListNumberedIcon";

exports.SvgListNumberedIcon = SvgListNumberedIcon;
